import {Component, OnInit, forwardRef, ChangeDetectorRef, Injector} from '@angular/core';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { GedDesignerModel } from '../ged-designer.model';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { GedDesignerModalComponent } from '../ged-designer-modal/ged-designer-modal.component';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { ResponseWorkflowService } from 'src/app/core-api/services/responses/response-workflow.service';

@Component({
    selector: 'abw-ged-designer-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => GedDesignerFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => GedDesignerFormComponent),
        multi: true
      }
    ],
    templateUrl: './ged-designer-form.component.html',
    styleUrls: ['./ged-designer-form.component.scss']
})
export class GedDesignerFormComponent extends AbstractWorkflowFormComponent<GedDesignerModel, any> {
    loading = false;
    base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

    constructor(
        private _dialog: MatDialog,
        private _responseWorkflowService: ResponseWorkflowService,
        _workflowComponentsService: WorkflowComponentsService,
        _cdf: ChangeDetectorRef,
        _injector: Injector
	) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    async writeValue(value: any) {
        if (!!value && !!value.FILE_TEMPLATE && !this.base64regex.test(value.FILE_TEMPLATE)) {
            const base64FileTemplate = await this.doGetFileContent(value.FILE_TEMPLATE);
            if (!!base64FileTemplate) {
                value.FILE_TEMPLATE = base64FileTemplate;
            }
        }
        this.value = value; 
    }

    openDesignerDialog() {
        const dialogRef = this._dialog.open(GedDesignerModalComponent, {
            data: {
                template: this.value
            },
            width: '100%',
            panelClass: 'ged-designer-modal'
        });
        dialogRef.afterClosed().subscribe((_result?: any) => {
            if (!_result) { return; }
            this.onValueChanged(_result);
        });
    }

    private doGetFileContent(_filename: string) {
        return new Promise((resolve, reject) => {
            this.loading = true; 
            this._responseWorkflowService.doReadResponseWorkflowFile(CODE_WORKFLOW_COMPONENT.GED_DESIGNER, _filename).then(_fileContent => {
                this.loading = false;
                resolve(_fileContent)
            }, (err) => {
                this.loading = false;
                reject(err);
            });
        });
    }
}